export class NavigationException extends Error {}
export class BeforeLeaveNavigationException extends NavigationException {}
